import {getNextScreen, getParamsFromString, getSafe, successMessage} from "../Components/JsonScreen/Utils";
import {fetchApplication, setDrawerState, setUserLanguage, toggleDrawer} from "./app.slice";
import {
    clearFile,
    completeTask,
    deleteTask,
    disableAllFields, enableAllFields,
    getListData,
    jsExecutor,
    readRecord,
    refreshData,
    sendRequest,
    setCameraScreenshotContent,
    setFieldValue,
    setFilter,
    setFormData,
    setGlobalValues,
    setIsChanged,
    setListData,
    setLoading,
    setPopup,
    setSession,
    setVariable,
    startProcess,
    startTask,
    uploadFile
} from "../Components/JsonScreen/jsonScreen.slice";
import {multiLanguageValue, paramGetter, scrollToElement} from "../Components/JsonScreen/Utils/lib";
import request from "../Services/API/Requests";
// import {saveAs} from 'file-saver';
import {useDispatch, useSelector} from "react-redux";
import {useSnackbar} from "notistack";
import useConfirm from "../Components/JsonScreen/Utils/Confirmation/useConfirm";
import {useHistory} from "react-router-dom";
import {del, set} from "object-path-immutable";
import findByString from "../Utils/Form/FormDynamic/Utils/getValueByString";
import usePopup from "../Components/JsonScreen/PopupScreen/usePopup";
import {useRef} from "react";
import {useLocation, useParams} from "react-router";
import {openContextMenu} from "../Components/JsonScreen/Screen/ScreenComponents/ContextMenu/contextMenu.slice";
import {
    setPrevListState
} from "../Components/JsonScreen/Screen/ScreenComponents/ListScreenComponent/List/enqueryList.slice";
import html2canvas from "html2canvas";
import {useDeepCompareCallback} from "use-deep-compare";
import {
    onOpenAvatarUpload
} from "../Components/JsonScreen/Screen/ScreenComponents/UploadAvatarPopupComponent/uploadAvatar.slice";

export const useActions = (customActions) => {
    const {
        globalValues,
        screenName,
        popup: popupState,
        isChangedFields,
        screen
    } = useSelector(state => state.jsonScreen);
    const appLanding = useSelector(state => state.app.appLanding);
    const isOpenDrawer = useSelector(state => state.app.isOpenDrawer);
    const application = useSelector(state => state.app.application);
    const userLanguage = useSelector(state => state.app.userLanguage);
    const list = useSelector(state => state.enqueryList);

    const cameraRef = useRef();
    const {enqueueSnackbar} = useSnackbar();
    const {confirm} = useConfirm();
    const {popup, closePopup} = usePopup();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const params = useParams();

    /**
     *
     * @type {(function(*, *=, *): Promise<void>)|*}
     */
    const doActions = useDeepCompareCallback(async (actions, context = {}, event, screenName, preScript) => {
        let tmpStatus = {};
        //TODO for executeJs type, add param who is calling and pass id and other params to identify which script should be called
        // add in top script before start main script
        if (!Array.isArray(actions)) {
            actions = [actions];
        }

        function setStatus(status) {
            tmpStatus = status
        }

        for (let action of actions) {
            switch (action.type) {
                case 'message':
                    await new Promise(resolve => showMessage(action, context, resolve, setStatus))
                    break;
                case 'nextScreen':
                    nextScreenAction(action, context, true);
                    break
                case 'cancel':
                    await cancel(action.showConfirm, action, context, true);
                    break
                case 'openPopup':
                    openPopupAction(action, context, screenName, true)
                    break;
                case 'openDrawer':
                    openDrawerAction(action, context, screenName)
                    break;
                case 'toggleSidebar':
                    dispatch(toggleDrawer())
                    break
                case 'setVariable':
                    dispatch(setVariable({action, context, screenName}))
                    break
                case 'sendRequest':
                    await new Promise(async resolve => await sendRequestAction(action, context, resolve, screenName));
                    break
                case 'uploadFile':
                    dispatch(uploadFile({action, screenName}))
                    break;
                case 'downloadFile':
                    await downloadFileAction(action, context, screenName, true)
                    break;
                case 'refreshData':
                    dispatch(refreshData(action))
                    break;
                case 'setFilter':
                    dispatch(setFilter({action, context, screenName}))
                    break;
                case 'readRecord':
                    dispatch(readRecord({action, context, screenName}))
                    break;
                case 'getListData':
                    dispatch(getListData({action, screenName}))
                    break;
                case 'setListData':
                    dispatch(setListData({action, screenName, fromAction: true}))
                    break;
                case 'returnValue':
                    returnValue(action, context, screenName, true);
                    break;
                case 'startProcess':
                    await startCamundaProcess(action, context, true, screenName)
                    break;
                case 'completeTask':
                    await completeTaskAction(action, context, true, screenName)
                    break;
                case 'deleteTask':
                    await deleteTaskAction(action, context, screenName)
                    break;
                case 'startTask':
                    await startTaskAction(action, context, true, screenName)
                    break;
                case 'createEntity':
                    await saveEntityActions(action, 'create', screenName, context);
                    break;
                case 'updateEntity':
                    await saveEntityActions(action, 'update', screenName, context);
                    break;
                case 'deleteEntity':
                    await deleteEntityAction(action, screenName);
                    break;
                case 'openContext':
                    await openContextMenuEvent(action, context, event, screenName)
                    break;
                case 'disableAllFields':
                    dispatch(disableAllFields({screenName}))
                    break;
                case 'enableAllFields':
                    dispatch(enableAllFields({screenName}))
                    break;
                case 'executeJs':
                    await new Promise(resolve => executeJs(action, {
                        ...context,
                        _status: tmpStatus,
                    }, false, resolve, screenName, preScript))
                    break;
                case 'externalLink':
                    openExternalLink(action, context, screenName);
                    break;
                case 'scrollToBlock':
                    const dest = getParamsFromString(action.destination, {...globalValues, ...context}, screenName);
                    scrollToElement(dest, action.value)
                    break;
                case 'cameraScreenshot':
                    cameraScreenShot(action, context, screenName)
                    break;
                case 'uploadAvatar':
                    //
                    console.log(action)
                    dispatch(onOpenAvatarUpload(action))
                    break
                default:
                    console.log('undefined action: \n', action)
                    break
            }
        }
    }, [
        globalValues, screenName, popupState, application, isOpenDrawer, screen, list, userLanguage])


    //actions
    async function executeJs(action, context = {}, shouldReturn, resolve, screenName, preScript) {
        const {value} = action;

        const actions = {
            setVariable: (destination, data, screenNameParam) => dispatch(setVariable({
                action: {destination, param: [{value: [data]}]},
                context,
                screenName,
                screenNameParam
            })),
            setFormData: (entity, values) => {
                dispatch(setFormData({entity, values}))
            },
            showMessage: async (action) => await new Promise(resolve => showMessage(action, context, resolve)),
            setFilter: (action) => {
                dispatch(setFilter({action, screenName}))
            },
            startProcess: (action, context) => startCamundaProcess(action, context, false, screenName),
            completeTask: (action, context) => completeTaskAction(action, context, false, screenName),
            deleteTask: (action, context) => deleteTaskAction(action, context, screenName),
            refreshData: (action) => {
                dispatch(refreshData(action))
            },
            nextScreen: (action, actContext = {}, unblocked) => nextScreenAction(action, {...actContext, ...context}, false, unblocked),
            openPopup: (action, context) => openPopupAction(action, context, screenName),
            setLoading: (isLoading) => dispatch(setLoading(isLoading)),
            disableAllFields: () => dispatch(disableAllFields({screenName})),
            enableAllFields: () => dispatch(enableAllFields({screenName})),
            fetchApplication: async (app) => {
                const res = await dispatch(fetchApplication(app))
                const appLanding = res.payload?.landingRes;
                const userInfo = await request({
                    url: "/user/getUserInfo",
                    data: {}
                })
                dispatch(setSession({key: 'user', value: userInfo}))
                //do onload events
                if (appLanding && appLanding.events && appLanding.events.length) {
                    if (appLanding.events[0].event === 'onOpen') {
                        await doActions(appLanding.events[0].actions, {}, null, appLanding.id, appLanding.script)
                    }
                }
            },
            clearFile: (action) => dispatch(clearFile({action, screenName})), //action - {fieldId: ""} where field id is path from upload action
            setSessionStorage: (key, value) => {
                dispatch(setSession({key, value}))
            },
            setUserLanguage: (lng) => dispatch(setUserLanguage(lng)),
            returnValue: (action, context) => returnValue(action, context, screenName),
            cancel: (showConfirm, action, context, unblocked) => cancel(showConfirm || false, action, context, false, unblocked),
            toggleSidebar: () => dispatch(toggleDrawer()),
            setSidebarState: (value) => dispatch(setDrawerState(value)),
            externalLink: (action) => openExternalLink(action, context, screenName),
            downloadFile: (action) => downloadFileAction(action, context, screenName, false),
            cameraScreenshot: ({destination, dimensions}, context) => cameraScreenShot({
                destination,
                dimensions
            }, context, screenName),
            uploadFile: (action) => dispatch(uploadFile({action, screenName})),
            htmlToPng: async (blockId, styles = {}, format) => {
                const element = document.getElementById(blockId);
                const canvas = await html2canvas(element, {
                    onclone: (document, element) => {
                        element.style.width = styles.width || element.style.width || "auto"
                        element.style.height = styles.height || element.style.height || 'auto'
                        element.style.borderRadius = styles.borderRadius || element.style.borderRadius || 'auto'
                    }
                })
                return canvas.toDataURL('image/png')
            }
        };
        let returnValues = await dispatch(jsExecutor({
            action: {
                actions,
                value,
                context
            },
            screenName,
            generatedScript: preScript ? preScript : screen[screenName]?.script
        }))
        if (shouldReturn) {
            return returnValues
        }
        resolve && resolve();

    }

    function showMessage(action, context, resolve, setStatus) {
        const {value, msgType, isPopup, title, buttons, width} = action;
        const multiLanguageV = multiLanguageValue(value, userLanguage)
        const newMessage = getParamsFromString(multiLanguageV, {...globalValues, ...context}, screenName);
        if (isPopup) {
            confirm({
                text: newMessage,
                submitLabel: 'Yes',
                cancelLabel: 'No',
                width,
                msgType,
                title,
                buttons,
                submitFn: () => {
                    resolve()
                },
                clickedCallback: (clicked) => {
                    setStatus && setStatus(clicked)
                    resolve(clicked);
                }
            })
            return;
        }
        enqueueSnackbar(newMessage, {variant: msgType});
        resolve && resolve()
    }

    function nextScreenAction(action, context = {}, fromAction, unblocked = false) {
        let onCloseActionBody = {
            msgType: 'success',
            value: "Test Message",
            title: "Test Title",
            isPopup: true,
            buttons: {
                "ro": ["Da", "Nu"],
                "en": ["Yes", "No"]
            }
        }
        history.block(() => {
            if (screen[screenName]?.events) {
                const onCloseEvent = screen[screenName].events.find(v => v.event === 'onClose')
                const onCloseAction = onCloseEvent?.actions?.find(v => v.type === 'confirmCloseScreen')
                const jsExecAction = onCloseEvent?.actions?.find(v => v.type === 'executeJs')

                //execute onClose js actions
                if(jsExecAction) {
                    doActions(jsExecAction, {}, null, screenName, screen.script)
                }
                if (!onCloseEvent || !onCloseAction) {
                    return true
                }
                onCloseActionBody = onCloseAction

            } else {
                return true
            }


            if (unblocked) return true
            new Promise(resolve => {
                showMessage(onCloseActionBody, {}, resolve)
            }).then(res => {
                if (res === 1) {
                    nextScreenAction(action, context = {}, fromAction, true)
                    return true;
                }
                return false
            }).catch(() => {
                return true
            })
            return false
        });

        const {url, nextScreen} = getNextScreen(action.destination, screenName, {
            ...globalValues, ...context,
            application
        });
        const pathStack = location.state ? !context.clearStack ? [
            ...location.state.pathStack || [], {
                path: params.name, state: {
                    prevListState: context._prevListState ? context._prevListState : null,
                }
            }] : [] : [];
        const inParam = fromAction ? paramGetter({
            action,
            globalValues: {list, ...globalValues, ...context, application},
            screenName
        }) : action.params;
        //next screen action
        if (action.anchor) {
            scrollToElement(action.anchor)
        }
        if (nextScreen === '__' || !nextScreen) {
            enqueueSnackbar('No destination', {variant: 'error'});
        } else if (nextScreen === 'prevScreen') {
            history.goBack();
        } else {
            dispatch(setPrevListState(context._prevListState))
            history.push({
                pathname: url,
                hash: action.anchor,
                state: {
                    inParam: {
                        ...globalValues.inParam,
                        [nextScreen]: inParam,
                    },
                    stackState: {
                        [params.name]: {
                            prevListState: context._prevListState ? context._prevListState : null,
                        }
                    },
                    prevListState: context._prevListState ? context._prevListState : null,
                    prevScreenId: params.name,
                    pathStack
                }
            });
        }
    }

    async function cancel(showConfirm = true, action = {}, context = {}, fromAction = true, unblocked = false) {
        const {name: popupName, returnPath, parentScreen} = popupState[screenName] || {};
        //used for custom actions, passed from core components
        if (customActions && customActions.cancel) {
            customActions.cancel();
            return
        }

        let onCloseActionBody = {
            msgType: 'success',
            value: "Test Message",
            title: "Test Title",
            isPopup: true,
            buttons: {
                "ro": ["Da", "Nu"],
                "en": ["Yes", "No"]
            }
        }
        history.block(() => {

            if (screen[screenName].events) {
                const onCloseEvent = screen[screenName].events.find(v => v.event === 'onClose')
                const onCloseAction = onCloseEvent?.actions?.find(v => v.type === 'confirmCloseScreen')
                if (!onCloseEvent || !onCloseAction) {
                    return true
                }
                onCloseActionBody = onCloseAction

            } else {
                return true
            }


            if (unblocked) return true

            new Promise(resolve => {
                showMessage(onCloseActionBody, {}, resolve)
            }).then(res => {
                if (res === 1) {
                    cancel(showConfirm, action, context, fromAction, true)
                    return true;
                }
                return false
            }).catch(() => {
                return true
            })
            return false
        });

        //unblock();
        if (popupName) {
            closePopup(false, popupName);
            return
        }

        if (!location.state) {
            history.goBack();
            return
        }
        const locStack = location.state.pathStack || [];
        const pathStack = locStack ? locStack.slice(0, locStack.length - 1) : []
        const prevScreenId = (locStack[locStack.length - 1] || {}).path || location.state.prevScreenId;

        const {url} = getNextScreen(prevScreenId, screenName, {
            ...globalValues, ...context,
            application
        });
//if in stack found this screen, remove from this index to end
        const inParam = fromAction ? paramGetter({
            action,
            globalValues: {list, ...globalValues, ...context, application},
            screenName
        }) : action.params;
        try {
            if (showConfirm && isChangedFields) {
                await new Promise((resolve, reject) => confirmLeavePage(resolve, reject))
            }


            if (location.state && location.state.prevScreenId) {
                history.push({
                    pathname: url,
                    state: {
                        inParam: {
                            ...location.state.inParam,
                        },
                        prevState: location.state.prevState,
                        prevListState: location.state.prevListState,
                        prevScreenId: params.name,
                        pathStack
                    }
                });
                return
            }
            history.goBack();
        } catch (err) {
            console.log('Rejected cancel')
        }

    }

    function openPopupAction(action, context, screenName, fromAction) {
        const {destination, returnPath, events, returnValue, width, height} = action;
        const {nextScreen} = getNextScreen(destination, screenName, {...globalValues, ...context});
        const inParam = fromAction ? paramGetter({
            action,
            globalValues: {
                ...globalValues.param[screenName] || {},
                inParam: globalValues.inParam,
                ...context
            },
            screenName
        }) : context;
        dispatch(setPopup({
            name: nextScreen,
            returnPath,
            parentScreen: screenName
        }));
        const onCloseActions = findByString(events, '0.actions') || [];
        popup({
            name: nextScreen,
            returnPath,
            inParam,
            returnValue,
            width,
            height,
            onCloseActions: () => doActions(onCloseActions, {...context}, null, screenName),
        })
    }

    function openDrawerAction(action, context) {
        const {destination, returnPath, events, returnValue, width, height} = action;
        const {nextScreen} = getNextScreen(destination, screenName, globalValues);

        const inParam = paramGetter({
            action,
            globalValues: {
                ...globalValues.param[screenName] || {},
                inParam: globalValues.inParam,
                ...context
            },
            screenName
        });
        dispatch(setPopup({
            name: nextScreen,
            returnPath,
            parentScreen: screenName
        }));
        const onCloseActions = findByString(events, '0.actions') || [];
        popup({
            name: nextScreen,
            presentation: "drawer",
            returnPath,
            inParam,
            returnValue,
            width,
            height,
            onCloseActions: () => doActions(onCloseActions, {}, null, screenName),
        })
    }

    function returnValue(action, context, screenName, fromAction) {
        const {name: popupName, returnPath, parentScreen} = popupState[screenName] || {};

        const data = fromAction ?
            paramGetter({action, globalValues: {...globalValues.param[screenName], ...context}, screenName}) :
            context;

        let newValues = set(globalValues.param[returnPath ? parentScreen : screenName], returnPath ? returnPath : '', data);

        dispatch(setGlobalValues({
            screenName: returnPath ? parentScreen : screenName,
            data: newValues
        }));

        //used for internal core components (list designer)
        if (context.returnValueFunction) {
            context.returnValueFunction(newValues)
        }
        if (popupName && returnPath) {
            closePopup(false, popupName)
        }
    }


    async function startCamundaProcess(action, context, fromAction, screenName) {
        await dispatch(startProcess({action, context, fromAction, screenName}))
            .unwrap()
            .then(res => {
                if (action.ignoreActions) return;
                if (res && res._actions) {
                    const clearActions = del(res, '_actions');
                    doActions(res._actions, {task: clearActions}, null, screenName);
                }
            }).catch(err => {
                fromAction && errHandlerSnackbar(err)
                if (!fromAction) {
                    throw err
                }
            })
    }

    async function completeTaskAction(action, context, fromAction, screenName) {
        await dispatch(completeTask({action, context, fromAction, screenName}))
            .unwrap()
            .then(res => {
                if (action.ignoreActions) return;
                if (res && res._actions) {
                    const clearActions = del(res, '_actions');
                    doActions(res._actions, {task: clearActions}, null, screenName);
                }
            }).catch(err => {
                fromAction && errHandlerSnackbar(err)
                if (!fromAction) {
                    throw err
                }
            })
    }

    async function startTaskAction(action, context, fromAction, screenName) {
        await dispatch(startTask({action, context, fromAction, screenName}))
            .unwrap()
            .then(res => {
                if (action.ignoreActions) return;
                if (res && res._actions) {
                    const clearActions = del(res, '_actions');
                    doActions(res._actions, {task: clearActions}, null, screenName);
                }
            }).catch(err => {
                fromAction && errHandlerSnackbar(err)
                if (!fromAction) {
                    throw err
                }
            })
    }

    async function deleteTaskAction(action, context, screenName) {
        await dispatch(deleteTask({action, context, screenName}))
            .unwrap()
            .then(() => {
            })
            .catch(err => {
                errHandlerSnackbar(err)
            })
    }

    async function sendRequestAction(action, context, resolve, screenName) {
        await dispatch(sendRequest({action, context, screenName}))
            .unwrap()
            .then(res => {
                if (res && res.data && res.data._actions) {
                    const clearActions = del(res.data, '_actions');
                    doActions(res.data._actions, {task: clearActions}, null, screenName);
                    resolve && resolve()
                    return
                }
                resolve && resolve()
            })
            .catch(e => {
                errHandlerSnackbar(e)
            })
    }

    async function downloadFileAction(action, context, screenName, fromAction) {
        const data = fromAction ?
            paramGetter({action, globalValues: {...globalValues, ...context}, screenName}) :
            action.param
        const {setToVar, destination} = action;
        try {
            dispatch(setLoading(true))
            let blob = await request({
                url: destination,
                method: 'POST',
                data: data,
            });
            dispatch(setLoading(false))
            let fileName = blob.name;
            let fileBlob = blob.content;
            downloadBase64File(fileBlob, fileName)
           // await saveAs(fileBlob, fileName);
            if (setToVar) {
                dispatch(setVariable({
                    action: {
                        destination: `${screenName}.${setToVar}`,
                        param: [{value: [{name: fileName, content: fileBlob}]}]
                    }, context
                }))
            }
        } catch (err) {
            console.log(err)
            dispatch(setLoading(false))
            errHandlerSnackbar(err)
        }
    }

    async function saveEntityActions(action, type, screenName, context) {
        const {destination} = action;
        try {
            const response = await dispatch(sendRequest({
                action: {
                    ...action,
                    destination: `/${destination}/${type}`,
                    param: [
                        {
                            value: [`{${destination}}`] //[globalValues.param[screenName][destination]]
                        }
                    ]
                },
                screenName,
                context: {}
            })).unwrap();
            dispatch(setIsChanged(false));
            const multiLanguageResponse = multiLanguageValue(response.data.id, userLanguage);
            await cancel(false);
            if (context && context.returnValueFunction) {
                context.returnValueFunction(response)
            }
            enqueueSnackbar(successMessage(
                    multiLanguageResponse,
                    history, location.pathname, location.state ? location.state.prevState : null),
                {variant: `success`});
        } catch (err) {
            console.log(err)
            errHandlerSnackbar(err, destination)
        }
    }

    async function deleteEntityAction(action, screenName) {
        const {destination} = action;
        dispatch(setIsChanged(false));
        confirm({
            text: 'Do you want to delete this record?',
            msgType: 'warning',
            submitLabel: 'Yes',
            cancelLabel: 'No',
            title: 'Confirmation',
            submitFn: async () => {
                const recordId = params.id ? params.id : getParamsFromString('{inParam.id}', globalValues, screenName);
                await dispatch(sendRequest({
                    action: {
                        ...action,
                        destination: `${destination}/delete`,
                        param: [{value: [{id: recordId}]}]
                    },
                    context: {}
                })).unwrap()
                    .then(async () => {
                        await cancel(false);
                        enqueueSnackbar('Success', {variant: 'success'});
                    })
                    .catch(err => {
                        errHandlerSnackbar(err)
                    })

            },
            cancelFn: () => {
            },
            clickedCallback: () => {
            }
        })
    }

    async function openContextMenuEvent(action, context, event, screenNameProp) {
        const {destination} = action;
        let otherComponents = [];

        //action called from application landing screen
        if (screenName !== screenNameProp) {
            if (appLanding.id === screenNameProp) {
                otherComponents = appLanding.otherComponents || [];
            }
        } else {
            otherComponents = screen[screenName].otherComponents || [];
        }

        const currentContext = otherComponents.filter(i => i.type === 'context').filter(i =>
            i.properties ? i.properties.context === destination : false
        );
        if (currentContext.length && event.clientX && event.clientY) {
            //check if context name exists
            if (currentContext[0].properties && currentContext[0].properties.context) {
                dispatch(openContextMenu({
                    anchor: {
                        mouseX: event.clientX - 2,
                        mouseY: event.clientY - 4,
                    },
                    anchorTarget: event.currentTarget,
                    currentId: currentContext[0].properties.context,
                    actionContext: context,
                }))
            }
        }
    }

    function confirmLeavePage(resolve, reject) {
        confirm({
            text: 'You have unsaved information, are you sure ?',
            msgType: 'warning',
            submitLabel: 'Yes',
            cancelLabel: 'No',
            title: 'Confirmation',
            submitFn: async () => {
                resolve();
            },
            cancelFn: async () => {
                reject();
            },
            clickedCallback: () => {
            }
        })
    }

    function errHandlerSnackbar(err, entity) {
        if (err.data !== undefined) {
            let errArr = getSafe(() => err.data.status.message, []);
            let fieldErrors = [];
            if (!Array.isArray(errArr)) {
                enqueueSnackbar('Error', {variant: 'error'});
                return
            }
            errArr.forEach(e => {
                if (!e.field) {
                    enqueueSnackbar(e.text, {variant: e.type});
                } else {
                    fieldErrors.push(e);
                    // enqueueSnackbar(`field "${e.field}": ${e.text}`, {variant: e.type});
                }
            });
            dispatch(setFormData({
                entity,
                values: {
                    status: {
                        message: fieldErrors
                    }
                }
            }))
            // this.setState({errors: fieldErrors});
        } else {
            enqueueSnackbar('Error', {variant: 'error'})
        }
    }

    function onChangeFields(value, path, trackChange) {
        dispatch(setFieldValue({value, path, trackChange}))
    }

    function openExternalLink(action, context, screenName) {
        const {destination, mode} = action;
        const executedLink = getParamsFromString(destination, {...globalValues, ...context, screenName});
        const regex = new RegExp(/^(http|https):/)
        const isHttpPrefix = regex.test(executedLink)
        Object.assign(document.createElement('a'), {
            target: mode || '_blank',
            href: isHttpPrefix ? executedLink : 'http://' + executedLink,
        }).click();
    }

    function cameraScreenShot(action, context, screenName) {
        if (cameraRef && cameraRef.current) {
            const {destination, dimensions} = action;
            if (destination) {
                try {
                    const imageSource = cameraRef.current.getScreenshot(dimensions);
                    if (!imageSource) {
                        enqueueSnackbar('Camera is not available, please connect web camera or give permission for the browser', {variant: 'error'})
                    }
                    dispatch(setCameraScreenshotContent({action, screenName, imageSource}))
                } catch (e) {
                    console.log('get screenshot error')
                }
            }


            return;
        }
        console.log('Camera is not available')
    }

    return {
        doActions,
        onChangeFields,
        cameraRef
    }
}


const base64ToBlob = (base64Data) => {
    let mimeType = '';
    let base64String = base64Data;

    // Extract MIME type if data URI
    if (base64Data.startsWith('data:')) {
        const parts = base64Data.split(',');
        if (parts.length >= 2) {
            mimeType = parts[0].split(';')[0].split(':')[1];
            base64String = parts[1];
        }
    }

    //Remove whitespaces
    const cleanedString = base64String.replace(/\s/g, '');

    const byteCharacters = atob(cleanedString);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: mimeType });
};

const downloadBase64File = (base64Data, filename) => {
    const blob = base64ToBlob(base64Data);
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = sanitizeFilename(filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
const sanitizeFilename = (filename) => {
    // Replace dots that are not before the final extension
    return filename
            .replace(/\.+/g, '_') // replace all dots with underscores

};